import React from 'react';
import { RubberDuckRoundsTable } from './RubberDuckRoundsTable';

export const RubberDuckRoundsList: React.FC = () => {
  return <RubberDuckRoundsTable />;
};
